<div>
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        [allowColumnResizing]="true"
        [columnAutoWidth]="true"
        [showBorders]="true"
    >
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

        <dxi-column dataField="car_init" caption="Car Init"></dxi-column>
        <dxi-column dataField="car_no" caption="Car No."></dxi-column>
        <dxi-column
            dataField="ship_date_time"
            caption="Ship Date"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="supplier_code" caption="Supplier Code"></dxi-column>
        <dxi-column dataField="supplier_name" caption="Supplier Name"></dxi-column>
        <dxi-column dataField="cust_no" caption="Cust No."></dxi-column>
        <dxi-column dataField="cust_name" caption="Customer"></dxi-column>
        <dxi-column dataField="fleet_id" caption="Fleet"></dxi-column>
        <dxi-column dataField="business_group" caption="Business Group"></dxi-column>
        <dxi-column dataField="dest_city" caption="Destination"></dxi-column>
        <dxi-column dataField="dest_state" caption="St"></dxi-column>
        <dxi-column dataField="car_status" caption="Car Status"></dxi-column>
        <dxi-column dataField="loc_city" caption="Location"></dxi-column>
        <dxi-column dataField="loc_state" caption="St"></dxi-column>
        <dxi-column dataField="sight_code" caption="Code"></dxi-column>
        <dxi-column
            dataField="clm_date_time"
            caption="CLM Date"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="le" caption="L/E"></dxi-column>
        <dxi-column dataField="road" caption="Road"></dxi-column>
        <dxi-column dataField="trn_jct" caption="Train/Jct"></dxi-column>
        <dxi-column dataField="comm_code" caption="Comm Code"></dxi-column>
        <dxi-column dataField="comm_short_name" caption="Comm Name"></dxi-column>
        <dxi-column dataField="comm_amt" caption="Amount"></dxi-column>
        <dxi-column dataField="bol_no" caption="BOL No."></dxi-column>
        <dxi-column
            dataField="orig_eda_eta_origin"
            caption="ETA to Origin"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column
            dataField="orig_eda_eta_cust"
            caption="ETA to Cust"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="hot_list_flag" caption="Hot List"></dxi-column>
        <dxi-column dataField="hot_list_flag_mech" caption="HL Mech"></dxi-column>
        <dxi-column dataField="hot_list_flag_leas" caption="HL Leas"></dxi-column>
        <dxi-column dataField="trouble_yorn" caption="Trouble"></dxi-column>
        <dxi-column dataField="COMMENTS" caption="Comments"></dxi-column>
        <dxi-column dataField="ecomment_code" caption="Expeditor Comment"></dxi-column>
        <dxi-column dataField="trip_ref1" caption="Ref 1" [visible]="false"></dxi-column>
        <dxi-column dataField="trip_ref2" caption="Ref 2" [visible]="false"></dxi-column>
        <dxi-column dataField="trip_ref3" caption="Ref 3" [visible]="false"></dxi-column>
        <dxi-column dataField="trip_ref4" caption="Ref 4" [visible]="false"></dxi-column>
        <dxo-summary>
            <dxi-total-item
                summaryType="count"
                displayFormat="Total Count: {0}"
                alignment="right"
            ></dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>
